import React, { useState, useEffect, useCallback, useRef, memo } from 'react'
import {
  useResponsive,
  IResponsiveType,
  computedResponsive,
} from 'Components/hooks/use-responsive'
import { sendTeaCommEvent } from 'lib/tea-analyze'
// import { publishSideNav } from 'New/side-nav/utils'
import useSideNavStatus, {
  resetSideNavStatus,
  setSideNavStatus,
} from 'Components/hooks/use-side-nav-status'
import style from './new-header-switch.module.scss'

const DEFAULT_TYPE = ''

function HeaderSwitch({ pageType = 'new' }: { pageType?: string }) {
  const navStatus = useSideNavStatus()
  const responsive = useResponsive()
  const [responsiveType, setResponsiveType] =
    useState<IResponsiveType>(DEFAULT_TYPE)

  // 是否手动点击触发
  const isHandle = useRef(false)

  useEffect(() => {
    setResponsiveType(computedResponsive())
    if (isHandle.current) {
      isHandle.current = false
    }
  }, [responsive])

  const handleClick = useCallback(() => {
    isHandle.current = true
    switch (navStatus) {
      case 'md-none':
        switch (responsiveType) {
          case 'sm':
          case 'md':
            setSideNavStatus('fixed')
            break
          default:
            setSideNavStatus('off')
        }
        break
      case 'fixed':
        setSideNavStatus('none')
        break
      case 'none':
        setSideNavStatus('fixed')
        break
      case 'on':
        setSideNavStatus('off')
        break
      case 'off':
        setSideNavStatus('on')
        break
      case 'md-off':
        switch (responsiveType) {
          case 'sm':
          case 'md':
            setSideNavStatus('on')
            break
          default:
            setSideNavStatus('off')
        }
        break
      case 'lg-off':
        switch (responsiveType) {
          case 'sm':
          case 'md':
          case 'lg':
            setSideNavStatus('on')
            break
          default:
            setSideNavStatus('off')
        }
        break
    }
  }, [navStatus, responsiveType])

  useEffect(() => {
    resetSideNavStatus()
    isHandle.current = false
  }, [responsive])

  useEffect(() => {
    if (isHandle.current) {
      switch (navStatus) {
        case 'on':
        case 'fixed':
          sendTeaCommEvent('clk_event', {
            event_id: 'common_menu_btn',
            shrink_type: 'unfold',
          })
          break
        case 'none':
        case 'off':
          sendTeaCommEvent('clk_event', {
            event_id: 'common_menu_btn',
            shrink_type: 'fold',
          })
          break
      }
    }
  }, [navStatus])

  return (
    <div
      className={`side-nav-switch ${style['side-nav-switch']}`}
      onClick={handleClick}
    >
      <button
        type="button"
        className={`arrow ${style['arrow']} ${navStatus}`}
      />
      <style jsx>
        {`
          .side-nav-switch {
            background: url(${require('static/icon-switch-btn.png')}) no-repeat
              0 0 / cover;
          }
        `}
      </style>
    </div>
  )
}

export default memo(HeaderSwitch)
